var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFillFromPersona(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.704,
    height: 14.471,
    viewBox: "0 0 14.704 14.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27289",
    "data-name": "Group 27289",
    transform: "translate(-450.533 -755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7369",
    "data-name": "Path 7369",
    d: "M729.422,1043.994a.425.425,0,0,0,.311-.14l3.018-3.154a.431.431,0,0,0-.311-.729h-1.58v-3.3a.72.72,0,0,0-.718-.718H728.7a.721.721,0,0,0-.718.718v3.3h-1.58a.431.431,0,0,0-.43.432.425.425,0,0,0,.119.3l3.016,3.154A.428.428,0,0,0,729.422,1043.994Z",
    transform: "translate(-267.634 -274.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_117",
    "data-name": "Subtraction 117",
    d: "M14816.837-5943.429h-6.5a.339.339,0,0,1-.339-.338,4.455,4.455,0,0,1,1.287-3.137,4.356,4.356,0,0,1,3.118-1.317h1.358a4.327,4.327,0,0,1,1.409.235,4.983,4.983,0,0,0-.731,2.6,4.972,4.972,0,0,0,.395,1.952Zm-1.75-5.47a3.055,3.055,0,0,1-3.052-3.051,3.055,3.055,0,0,1,3.052-3.051,3.053,3.053,0,0,1,3.047,3.051A3.053,3.053,0,0,1,14815.087-5948.9Z",
    transform: "translate(-14359.467 6710.001)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillFromPersona);
export default __webpack_public_path__ + "static/media/fill-from-persona.d0a5ee729c484745938857977616011c.svg";
export { ForwardRef as ReactComponent };